/**
 * proteinViewPage_DisplayData_ProteinList__Create_ProteinList_DataTable_RootTableDataObject.ts
 * 
 * Create DataTable_RootTableDataObject for Protein List for Single Search, Sub Groups, and Multiple Searches
 */

import React from "react";

import {
    DataTable_Column,
    DataTable_Column_DownloadTable,
    DataTable_DataGroupRowEntry,
    DataTable_DataRow_ColumnEntry,
    DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough,
    DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough_Params,
    DataTable_DataRow_ColumnEntry__valueDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough_Params,
    DataTable_DataRow_ColumnEntry_SearchTableData,
    DataTable_DataRowEntry,
    DataTable_DataRowEntry__tableRowClickHandler_Callback_NoDataPassThrough,
    DataTable_DataRowEntry__tableRowClickHandler_Callback_NoDataPassThrough_Params,
    DataTable_DataRowEntry_DownloadTable,
    DataTable_DataRowEntry_DownloadTable_SingleColumn,
    DataTable_RootTableDataObject,
    DataTable_RootTableDataObject_Both_ColumnArrays
} from 'page_js/data_pages/data_table_react/dataTable_React_DataObjects';

import {ProteinGrouping_CentralStateManagerObjectClass} from '../../protein_page_protein_list_common/proteinGrouping_CentralStateManagerObjectClass';
import {DataPageStateManager} from 'page_js/data_pages/data_pages_common/dataPageStateManager';
import {
    get_ProteinName_ProteinDescription_Tooltip_Contents
} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page__protein_list/jsx/proteinViewPage_DisplayData_ProteinList__ProteinName_ProteinDescription_DataTable_Component";
import {ProteinNameDescriptionCacheEntry} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page__protein_list/js/protein_view_page__display_data__protein_list__create_protein_display_data__before__not_grouped__grouped";
import {
    get_proteinViewPage_DisplayData__SearchSubGroup_Adjusted_Spectral_Count_ABACUS_Header_Text_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_Adjusted_Spectral_Count_ABACUS_Header_Tooltip_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_NSAF__Using__Adjusted_Spectral_Count_ABACUS_Header_Tooltip_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_NSAF__Using_Adjusted_Spectral_Count_ABACUS_Header_Text_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_NSAF_Header_Text_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_NSAF_Header_Tooltip_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_PSM_Count_Header_Text_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_PSM_Count_Header_Tooltip_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_SequenceCoverage_Header_Text_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_SequenceCoverage_Header_Tooltip_DataTable_Component
} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page_common/jsx/proteinViewPage_DisplayData__SearchSubGroup_PSM_Count_Header_Text_And_Tooltip_DataTable_Component";
import {
    get_proteinViewPage_DisplayData__SearchSubGroup_Peptide_Count_Header_Text_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_Peptide_Count_Header_Tooltip_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_PeptideUnique_Count_Header_Text_DataTable_Component,
    get_proteinViewPage_DisplayData__SearchSubGroup_PeptideUnique_Count_Header_Tooltip_DataTable_Component
} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page__protein_list/protein_page__protein_list__single_search_code/datatable_components/proteinViewPage_DisplayData__SearchSubGroup_Peptide_Count_Header_Text_And_Tooltip_DataTable_Component";
import {
    ProteinDataDisplay_ProteinList_Item,
    ProteinDisplayData_From_createProteinDisplayData_ProteinList
} from '../js/proteinViewPage_DisplayData_ProteinList__ProteinDisplayData_Classes';
import {ProteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page__protein_list/js/proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject";
import {proteinView_nsaf_formatNumber_ForDisplayInTable} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page_common/proteinView_nsaf_formatNumber_ForDisplayInTable";
import {
    SearchDataLookupParameters_Root,
    SearchDataLookupParams_For_Single_ProjectSearchId
} from "page_js/data_pages/data_pages__common_data_classes/searchDataLookupParameters";
import {
    proteinView_Adjusted_Spectral_Count_ABACUS_formatNumber_ForDisplayInTable
} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page_common/proteinView_Adjusted_Spectral_Count_ABACUS_formatNumber_ForDisplayInTable";
import {
    proteinView__ProteinList_ColumnHeader__Tooltip_Text
} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page_common/jsx/proteinView__ProteinList_ColumnHeader__Tooltip_Text";

const _TEXT_text_Optional_After_CurrentlyShowing_X_Of_Y__Proteins = "Proteins";
const _TEXT_text_Optional_After_CurrentlyShowing_X_Of_Y__ProteinGroups = "Protein Groups";

//  Strings used in the download of the table
const _FALSE__DOWNLOAD_STRING = "false";
const _TRUE__DOWNLOAD_STRING = "true";

///   Callback when row in protein list table is clicked

/**
 *
 */
export class ProteinViewPage_Display__singleProteinRow_ClickHandler_Params {
    proteinSequenceVersionId: number
    dataTable_DataRowEntry__tableRowClickHandler_Callback_NoDataPassThrough_Params: DataTable_DataRowEntry__tableRowClickHandler_Callback_NoDataPassThrough_Params
}

/**
 *
 */
export type ProteinViewPage_Display__singleProteinRow_ClickHandler = (params : ProteinViewPage_Display__singleProteinRow_ClickHandler_Params ) => void

/**
 * Create tableObject object  for DataTable
 */
export const proteinViewPage_renderToPageProteinList__Create_DataTable_RootTableDataObject = function(
    {
        singleProteinRowClickHandler_Callback,
        proteinDisplayData,
        proteinGrouping_CentralStateManagerObjectClass,
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject,
        searchSubGroupIds,
        projectSearchIds,
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId,
        dataPageStateManager_DataFrom_Server,
        searchDataLookupParamsRoot
    } : {
        singleProteinRowClickHandler_Callback : ProteinViewPage_Display__singleProteinRow_ClickHandler
        proteinDisplayData: ProteinDisplayData_From_createProteinDisplayData_ProteinList
        proteinGrouping_CentralStateManagerObjectClass : ProteinGrouping_CentralStateManagerObjectClass
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject: ProteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
        searchSubGroupIds : Array<number>  //  undefined or null when not applicable
        projectSearchIds : Array<number>
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId : Map<number, Array<ProteinNameDescriptionCacheEntry>>
        dataPageStateManager_DataFrom_Server : DataPageStateManager
        searchDataLookupParamsRoot: SearchDataLookupParameters_Root

    }) : DataTable_RootTableDataObject {

    // the columns for the data being shown on the page
    const dataTable_RootTableDataObject_Both_ColumnArrays : DataTable_RootTableDataObject_Both_ColumnArrays = _getProteinDataTableColumns( {
        projectSearchIds, searchSubGroupIds, dataPageStateManager_DataFrom_Server, proteinGrouping_CentralStateManagerObjectClass,
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject,
        searchDataLookupParamsRoot
    } );

    let dataTable_DataRowEntries : Array<DataTable_DataRowEntry> = undefined;
    let dataTable_DataGroupRowEntries : Array<DataTable_DataGroupRowEntry> = undefined;
    let text_Optional_After_CurrentlyShowing_X_Of_Y: string

    if ( ! proteinGrouping_CentralStateManagerObjectClass.isGroupProteins_No_Grouping() ) {

        text_Optional_After_CurrentlyShowing_X_Of_Y = _TEXT_text_Optional_After_CurrentlyShowing_X_Of_Y__ProteinGroups;

        //  YES Proteins ARE Grouped

        dataTable_DataGroupRowEntries = _renderToPageProteinList_Create_dataGroupObjects_YES_ProteinGroups({
            proteinDisplayData,
            projectSearchIds,
            searchSubGroupIds,
            dataPageStateManager_DataFrom_Server,
            searchDataLookupParamsRoot,
            proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId,
            singleProteinRowClickHandler_Callback,
            proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
        });

    } else {

        //  Proteins are NOT Grouped

        text_Optional_After_CurrentlyShowing_X_Of_Y = _TEXT_text_Optional_After_CurrentlyShowing_X_Of_Y__Proteins;

        const greyOutRow = false;  //  Not pass for not grouped

        dataTable_DataRowEntries = _renderToPageProteinList_Create_dataObjects_NO_ProteinGroups({
            groupNumber: undefined, greyOutRow, isSubsetGroup: undefined,
            proteinList: proteinDisplayData.proteinList,
            projectSearchIds, searchSubGroupIds, dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
            proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId, singleProteinRowClickHandler_Callback,
            proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
        });
    }

    const tableObject = new DataTable_RootTableDataObject({
        columns: dataTable_RootTableDataObject_Both_ColumnArrays.columns,
        columns_tableDownload: dataTable_RootTableDataObject_Both_ColumnArrays.columns_tableDownload,
        dataTable_DataRowEntries,
        dataTable_DataGroupRowEntries,
        text_Optional_After_CurrentlyShowing_X_Of_Y
    });

    return tableObject;
}


/**
 * Create Table Columns
 */
const _getProteinDataTableColumns = function(
    {
        projectSearchIds, searchSubGroupIds, dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot, proteinGrouping_CentralStateManagerObjectClass,
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject,
    } : {
        projectSearchIds : Array<number>
        searchSubGroupIds : Array<number>  //  undefined or null when not applicable
        dataPageStateManager_DataFrom_Server : DataPageStateManager
        searchDataLookupParamsRoot: SearchDataLookupParameters_Root
        proteinGrouping_CentralStateManagerObjectClass : ProteinGrouping_CentralStateManagerObjectClass
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject: ProteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject

    } ) : DataTable_RootTableDataObject_Both_ColumnArrays {

    //  For getting search info for projectSearchIds
    const searchData_SearchName_Etc_Root = dataPageStateManager_DataFrom_Server.get_searchData_SearchName_Etc_Root();

    let columns : Array<DataTable_Column> = [ ];
    const dataTable_Column_DownloadTable_Entries : Array<DataTable_Column_DownloadTable> = [];

    {
        const displayName = 'Protein(s)';

        const column = new DataTable_Column({
            id :           'proteins',
            displayName,
            width :        300,
            sortable : true
        });

        columns.push( column );

        const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
        dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
    }

    {
        const displayName = 'Protein Description(s)';

        const column = new DataTable_Column({
            id :           'protein_descriptions',
            displayName,
            width :        325,
            sortable : true
        });

        columns.push( column );

        const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
        dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
    }

    if ( ( ! searchSubGroupIds ) ) {

        //  NO Sub Group Ids so display Sequence Coverage

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_SequenceCoverage_Selected() ) {

            for ( const projectSearchId of projectSearchIds ) {

                let displayName = 'Sequence Coverage';

                const searchNameObject = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObject ) {
                    throw Error("No searchNameObject from searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId );
                }

                if ( projectSearchIds.length > 1 ) {

                    displayName += ' (' + searchNameObject.searchLabel__SearchShortName_OR_SearchId + ")";
                }

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () => {

                    let searchShortName_Label = ""

                    if ( searchNameObject.searchShortName ) {
                        searchShortName_Label = "(" + searchNameObject.searchShortName + ") "
                    }

                    const searchLabel = "(" + searchNameObject.searchId + ") " + searchShortName_Label + searchNameObject.name

                    return (
                        <>
                            <div>
                                { proteinView__ProteinList_ColumnHeader__Tooltip_Text.Sequence_Coverage }
                            </div>
                            <div style={ { marginTop: 5, fontWeight: "bold" } }>
                                Search:
                            </div>
                            <div style={ { marginTop: 2 } }>
                                { searchLabel }
                            </div>
                        </>
                    )
                }

                const column = new DataTable_Column({
                    id :           'protSeqCov_' + projectSearchId,
                    displayName,
                    width :        150,
                    sortable : true,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,

                    showHorizontalGraph: true,
                    graphMaxValue: 1,
                    graphWidth: 50,
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }
    }

    if ( projectSearchIds.length === 1 && searchSubGroupIds ) {

        //  Only 1 search  AND Sub Groups

        //  YES Sub Groups so display Sub Group data

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_SequenceCoverage_Selected() ) {

            const projectSearchId = projectSearchIds[0];

            const searchSubGroups_Root = dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root();
            if ( ! searchSubGroups_Root ) {
                throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root(); return nothing for projectSearchId: " + projectSearchId );
            }
            const searchSubGroups_ForProjectSearchId = searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId );
            if ( ! searchSubGroups_ForProjectSearchId ) {
                throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId ); return nothing for projectSearchId: " + projectSearchId );
            }

            for ( const searchSubGroupId of searchSubGroupIds ) {

                const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                if ( ! searchSubGroup ) {
                    throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                        + ", projectSearchId: " + projectSearchId );
                }

                const displayName = get_proteinViewPage_DisplayData__SearchSubGroup_SequenceCoverage_Header_Text_DataTable_Component({ searchSubGroup });

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () : React.JSX.Element => {

                    return get_proteinViewPage_DisplayData__SearchSubGroup_SequenceCoverage_Header_Tooltip_DataTable_Component({ searchSubGroup });
                }

                const column = new DataTable_Column({
                    id :           'protSeqCov_' + searchSubGroupId,
                    displayName,
                    width :        150,
                    sortable : true,

                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,

                    showHorizontalGraph: true,
                    graphMaxValue: 1,
                    graphWidth: 50,
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }
    }

    if ( projectSearchIds.length === 1 && ( ! searchSubGroupIds ) ) {

        //  Only 1 search and NOT Sub Groups

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_PsmCount_Selected() ) {

            // PSM count overall

            const displayName = 'PSMs';

            const column = new DataTable_Column({
                id :           'psms',
                displayName,
                width :        80,
                sortable : true,
                columnHeader_Tooltip_HTML_TitleAttribute: proteinView__ProteinList_ColumnHeader__Tooltip_Text.PSM_Count,
                onlyShow_ValueDisplay_FirstRowOfGroup: true
            });

            columns.push( column );

            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
            dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_Selected() ) {

            // NSAF overall

            const displayName = 'NSAF';

            const column = new DataTable_Column({
                id :           'nsaf',
                displayName,
                width :        80,
                sortable : true,
                columnHeader_Tooltip_HTML_TitleAttribute: proteinView__ProteinList_ColumnHeader__Tooltip_Text.NSAF,
                onlyShow_ValueDisplay_FirstRowOfGroup: false
            });

            columns.push( column );

            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
            dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_Adjusted_Spectral_Count_ABACUS_Selected() ) {

            // Adjusted_Spectral_Count_ABACUS overall

            const displayName = 'Adjusted Spectral Count (ABACUS)';

            const column = new DataTable_Column({
                id :           'Adjusted_Spectral_Count_ABACUS',
                displayName,
                width :        80,
                sortable : true,
                columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element: proteinView__ProteinList_ColumnHeader__Tooltip_Text.Adjusted_Spectral_Count__ABACUS__ReturnComponent,
                onlyShow_ValueDisplay_FirstRowOfGroup: true
            });

            columns.push( column );

            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
            dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_USING__Adjusted_Spectral_Count_ABACUS_Selected() ) {

            // NSAF Using Adjusted_Spectral_Count_ABACUS overall

            const displayName = 'NSAF: Adjusted Spectral Count (ABACUS)';

            const column = new DataTable_Column({
                id :           'NSAF_Adjusted_Spectral_Count_ABACUS',
                displayName,
                width :        80,
                sortable : true,
                columnHeader_Tooltip_HTML_TitleAttribute: proteinView__ProteinList_ColumnHeader__Tooltip_Text.NSAF_Using_Adjusted_Spectral_Count__ABACUS,
                onlyShow_ValueDisplay_FirstRowOfGroup: false
            });

            columns.push( column );

            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
            dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_DistinctPeptideCount_Selected() ) {

            //  Generated Reported Peptides count overall

            const displayName = 'Distinct Peptides';

            const column = new DataTable_Column({
                id: 'peptides',
                displayName,
                width: 80,
                sortable: true,
                columnHeader_Tooltip_HTML_TitleAttribute: proteinView__ProteinList_ColumnHeader__Tooltip_Text.Distinct_Peptide_Count,
                onlyShow_ValueDisplay_FirstRowOfGroup: true
            });

            columns.push(column);

            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({cell_ColumnHeader_String: displayName});
            dataTable_Column_DownloadTable_Entries.push(dataTable_Column_DownloadTable);
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_UniquePeptideCount_Selected() ) {

            //  Generated Reported Peptides Unique count overall

            const displayName = 'Unique Peptides';

            const column = new DataTable_Column({
                id: 'peptidesUnique',
                displayName,
                width: 80,
                // columnHeader_Tooltip_HTML_TitleAttribute: "distinct unique peptides",
                sortable: true,
                columnHeader_Tooltip_HTML_TitleAttribute: proteinView__ProteinList_ColumnHeader__Tooltip_Text.Unique_Peptide_Count,
                onlyShow_ValueDisplay_FirstRowOfGroup: true
            });

            columns.push(column);

            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({cell_ColumnHeader_String: displayName});
            dataTable_Column_DownloadTable_Entries.push(dataTable_Column_DownloadTable);
        }

    }

    if ( projectSearchIds.length === 1 && searchSubGroupIds ) {

        //  Only 1 search  AND Sub Groups

        //  YES Sub Groups so display Sub Group data

        const projectSearchId = projectSearchIds[0];

        const searchSubGroups_Root = dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root();
        if ( ! searchSubGroups_Root ) {
            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root(); return nothing for projectSearchId: " + projectSearchId );
        }
        const searchSubGroups_ForProjectSearchId = searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId );
        if ( ! searchSubGroups_ForProjectSearchId ) {
            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId ); return nothing for projectSearchId: " + projectSearchId );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_PsmCount_Selected() ) {

            for ( const searchSubGroupId of searchSubGroupIds ) {

                const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                if ( ! searchSubGroup ) {
                    throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                        + ", projectSearchId: " + projectSearchId );
                }

                const displayName = get_proteinViewPage_DisplayData__SearchSubGroup_PSM_Count_Header_Text_DataTable_Component({ searchSubGroup });

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () : React.JSX.Element => {

                    return get_proteinViewPage_DisplayData__SearchSubGroup_PSM_Count_Header_Tooltip_DataTable_Component({ searchSubGroup });
                }

                const column = new DataTable_Column({
                    id :           'psms_' + searchSubGroupId,
                    displayName,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    width :        80,
                    sortable : true,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_Selected() ) {

            for ( const searchSubGroupId of searchSubGroupIds ) {

                const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                if ( ! searchSubGroup ) {
                    throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                        + ", projectSearchId: " + projectSearchId );
                }

                const displayName = get_proteinViewPage_DisplayData__SearchSubGroup_NSAF_Header_Text_DataTable_Component({ searchSubGroup });

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () : React.JSX.Element => {

                    return get_proteinViewPage_DisplayData__SearchSubGroup_NSAF_Header_Tooltip_DataTable_Component({ searchSubGroup });
                }

                const column = new DataTable_Column({
                    id :           'nsaf_' + searchSubGroupId,
                    displayName,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    width :        80,
                    sortable : true,
                    onlyShow_ValueDisplay_FirstRowOfGroup: false
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_Adjusted_Spectral_Count_ABACUS_Selected() ) {

            for ( const searchSubGroupId of searchSubGroupIds ) {

                const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                if ( ! searchSubGroup ) {
                    throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                        + ", projectSearchId: " + projectSearchId );
                }

                const displayName = get_proteinViewPage_DisplayData__SearchSubGroup_Adjusted_Spectral_Count_ABACUS_Header_Text_DataTable_Component({ searchSubGroup });

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () : React.JSX.Element => {

                    return get_proteinViewPage_DisplayData__SearchSubGroup_Adjusted_Spectral_Count_ABACUS_Header_Tooltip_DataTable_Component({ searchSubGroup });
                }

                const column = new DataTable_Column({
                    id :           'Adjusted_Spectral_Count_ABACUS_' + searchSubGroupId,
                    displayName,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    width :        80,
                    sortable : true,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_USING__Adjusted_Spectral_Count_ABACUS_Selected() ) {

            for ( const searchSubGroupId of searchSubGroupIds ) {

                const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                if ( ! searchSubGroup ) {
                    throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                        + ", projectSearchId: " + projectSearchId );
                }

                const displayName = get_proteinViewPage_DisplayData__SearchSubGroup_NSAF__Using_Adjusted_Spectral_Count_ABACUS_Header_Text_DataTable_Component({ searchSubGroup });

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () : React.JSX.Element => {

                    return get_proteinViewPage_DisplayData__SearchSubGroup_NSAF__Using__Adjusted_Spectral_Count_ABACUS_Header_Tooltip_DataTable_Component({ searchSubGroup });
                }

                const column = new DataTable_Column({
                    id :           'NSAF_Adjusted_Spectral_Count_ABACUS_' + searchSubGroupId,
                    displayName,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    width :        80,
                    sortable : true,
                    onlyShow_ValueDisplay_FirstRowOfGroup: false
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

        for ( const searchSubGroupId of searchSubGroupIds ) {

            const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
            if ( ! searchSubGroup ) {
                throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                    + ", projectSearchId: " + projectSearchId );
            }

            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_DistinctPeptideCount_Selected() ) {

                //  Reported Peptides Count

                const displayName = get_proteinViewPage_DisplayData__SearchSubGroup_Peptide_Count_Header_Text_DataTable_Component({searchSubGroup});

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = (): React.JSX.Element => {

                    return get_proteinViewPage_DisplayData__SearchSubGroup_Peptide_Count_Header_Tooltip_DataTable_Component({searchSubGroup});
                }

                const column = new DataTable_Column({
                    id: 'peptides_' + searchSubGroupId,
                    displayName,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    width: 80,
                    sortable: true,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push(column);

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({cell_ColumnHeader_String: displayName});
                dataTable_Column_DownloadTable_Entries.push(dataTable_Column_DownloadTable);
            }

            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_UniquePeptideCount_Selected() ) {

                //  Reported Peptides Unique Count

                const displayName = get_proteinViewPage_DisplayData__SearchSubGroup_PeptideUnique_Count_Header_Text_DataTable_Component({searchSubGroup});

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = (): React.JSX.Element => {

                    return get_proteinViewPage_DisplayData__SearchSubGroup_PeptideUnique_Count_Header_Tooltip_DataTable_Component({searchSubGroup});
                }

                const column = new DataTable_Column({
                    id: 'peptidesUnique_' + searchSubGroupId,
                    displayName,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    width: 80,
                    sortable: true,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push(column);

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({cell_ColumnHeader_String: displayName});
                dataTable_Column_DownloadTable_Entries.push(dataTable_Column_DownloadTable);
            }
        }

    }

    if ( projectSearchIds.length > 1 ) {

        //  NOT Single Search.  Display data for Each Search

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_PsmCount_Selected() ) {

            //  PSM Counts

            for ( const projectSearchId of projectSearchIds ) {

                const searchNameObject = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObject ) {
                    throw Error("No searchNameObject from searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId );
                }

                const displayName = 'PSMs (' + searchNameObject.searchLabel__SearchShortName_OR_SearchId + ")";

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () => {

                    let searchShortName_Label = ""

                    if ( searchNameObject.searchShortName ) {
                        searchShortName_Label = "(" + searchNameObject.searchShortName + ") "
                    }

                    const searchLabel = "(" + searchNameObject.searchId + ") " + searchShortName_Label + searchNameObject.name

                    return (
                        <>
                            <div>
                                { proteinView__ProteinList_ColumnHeader__Tooltip_Text.PSM_Count }
                            </div>
                            <div style={ { marginTop: 5, fontWeight: "bold" } }>
                                Search:
                            </div>
                            <div style={ { marginTop: 2 } }>
                                { searchLabel }
                            </div>
                        </>
                    )
                }

                const column = new DataTable_Column({
                    id :           'psms_' + projectSearchId,
                    displayName,
                    width :        80,
                    sortable : true,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_Selected() ) {

            //  NSAF

            for ( const projectSearchId of projectSearchIds ) {

                const searchNameObject = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObject ) {
                    throw Error("No searchNameObject from searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId );
                }

                const displayName = 'NSAF (' + searchNameObject.searchLabel__SearchShortName_OR_SearchId + ")";

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () => {

                    let searchShortName_Label = ""

                    if ( searchNameObject.searchShortName ) {
                        searchShortName_Label = "(" + searchNameObject.searchShortName + ") "
                    }

                    const searchLabel = "(" + searchNameObject.searchId + ") " + searchShortName_Label + searchNameObject.name

                    return (
                        <>
                            <div>
                                { proteinView__ProteinList_ColumnHeader__Tooltip_Text.NSAF }
                            </div>
                            <div style={ { marginTop: 5, fontWeight: "bold" } }>
                                Search:
                            </div>
                            <div style={ { marginTop: 2 } }>
                                { searchLabel }
                            </div>
                        </>
                    )
                }

                const column = new DataTable_Column({
                    id :           'nsaf_' + projectSearchId,
                    displayName,
                    width :        80,
                    sortable : true,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    onlyShow_ValueDisplay_FirstRowOfGroup: false
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  Adjusted_Spectral_Count_ABACUS_

            for ( const projectSearchId of projectSearchIds ) {

                const searchNameObject = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObject ) {
                    throw Error("No searchNameObject from searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId );
                }

                const displayName = 'Adjusted Spectral Count (ABACUS) (' + searchNameObject.searchLabel__SearchShortName_OR_SearchId + ")";

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () => {

                    let searchShortName_Label = ""

                    if ( searchNameObject.searchShortName ) {
                        searchShortName_Label = "(" + searchNameObject.searchShortName + ") "
                    }

                    const searchLabel = "(" + searchNameObject.searchId + ") " + searchShortName_Label + searchNameObject.name

                    const Adjusted_Spectral_Count__ABACUS__ReturnComponent = proteinView__ProteinList_ColumnHeader__Tooltip_Text.Adjusted_Spectral_Count__ABACUS__ReturnComponent

                    return (
                        <>
                            <div>
                                <Adjusted_Spectral_Count__ABACUS__ReturnComponent/>
                            </div>
                            <div style={ { marginTop: 5, fontWeight: "bold" } }>
                                Search:
                            </div>
                            <div style={ { marginTop: 2 } }>
                                { searchLabel }
                            </div>
                        </>
                    )
                }

                const column = new DataTable_Column({
                    id :           'Adjusted_Spectral_Count_ABACUS__' + projectSearchId,
                    displayName,
                    width :        80,
                    sortable : true,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_USING__Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  NSAF Using Adjusted_Spectral_Count_ABACUS_

            for ( const projectSearchId of projectSearchIds ) {

                const searchNameObject = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObject ) {
                    throw Error("No searchNameObject from searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId );
                }

                const displayName = 'NSAF: Adjusted Spectral Count (ABACUS) (' + searchNameObject.searchLabel__SearchShortName_OR_SearchId + ")";

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () => {

                    let searchShortName_Label = ""

                    if ( searchNameObject.searchShortName ) {
                        searchShortName_Label = "(" + searchNameObject.searchShortName + ") "
                    }

                    const searchLabel = "(" + searchNameObject.searchId + ") " + searchShortName_Label + searchNameObject.name

                    return (
                        <>
                            <div>
                                { proteinView__ProteinList_ColumnHeader__Tooltip_Text.NSAF_Using_Adjusted_Spectral_Count__ABACUS }
                            </div>
                            <div style={ { marginTop: 5, fontWeight: "bold" } }>
                                Search:
                            </div>
                            <div style={ { marginTop: 2 } }>
                                { searchLabel }
                            </div>
                        </>
                    )
                }

                const column = new DataTable_Column({
                    id :           'NSAF_Adjusted_Spectral_Count_ABACUS__' + projectSearchId,
                    displayName,
                    width :        80,
                    sortable : true,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    onlyShow_ValueDisplay_FirstRowOfGroup: false
                });

                columns.push( column );

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
                dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
            }
        }

		//  Distinct Peptide and Unique Distinct Peptide Counts

        for ( const projectSearchId of projectSearchIds ) {

            const searchNameObject = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
            if ( ! searchNameObject ) {
                throw Error("No searchNameObject from searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId );
            }

            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_DistinctPeptideCount_Selected() ) {

                //  Reported Peptides count

                const displayName = 'Distinct Peptides (' + searchNameObject.searchLabel__SearchShortName_OR_SearchId + ")";

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () => {

                    let searchShortName_Label = ""

                    if ( searchNameObject.searchShortName ) {
                        searchShortName_Label = "(" + searchNameObject.searchShortName + ") "
                    }

                    const searchLabel = "(" + searchNameObject.searchId + ") " + searchShortName_Label + searchNameObject.name

                    return (
                        <>
                            <div>
                                { proteinView__ProteinList_ColumnHeader__Tooltip_Text.Distinct_Peptide_Count }
                            </div>
                            <div style={ { marginTop: 5, fontWeight: "bold" } }>
                                Search:
                            </div>
                            <div style={ { marginTop: 2 } }>
                                { searchLabel }
                            </div>
                        </>
                    )
                }

                const column = new DataTable_Column({
                    id: 'peptides_' + projectSearchId,
                    displayName,
                    width: 80,
                    sortable: true,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push(column);

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({cell_ColumnHeader_String: displayName});
                dataTable_Column_DownloadTable_Entries.push(dataTable_Column_DownloadTable);
            }

            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_UniquePeptideCount_Selected() ) {

                //  Reported Peptides Unique count

                const displayName = 'Unique Peptides (' + searchNameObject.searchLabel__SearchShortName_OR_SearchId + ")";

                const columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element = () => {

                    let searchShortName_Label = ""

                    if ( searchNameObject.searchShortName ) {
                        searchShortName_Label = "(" + searchNameObject.searchShortName + ") "
                    }

                    const searchLabel = "(" + searchNameObject.searchId + ") " + searchShortName_Label + searchNameObject.name

                    return (
                        <>
                            <div>
                                { proteinView__ProteinList_ColumnHeader__Tooltip_Text.Unique_Peptide_Count }
                            </div>
                            <div style={ { marginTop: 5, fontWeight: "bold" } }>
                                Search:
                            </div>
                            <div style={ { marginTop: 2 } }>
                                { searchLabel }
                            </div>
                        </>
                    )
                }

                const column = new DataTable_Column({
                    id: 'peptidesUnique_' + projectSearchId,
                    displayName,
                    width: 80,
                    sortable: true,
                    columnHeader_Tooltip_Fcn_NoInputParam_Return_JSX_Element,
                    onlyShow_ValueDisplay_FirstRowOfGroup: true
                });

                columns.push(column);

                const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({cell_ColumnHeader_String: displayName});
                dataTable_Column_DownloadTable_Entries.push(dataTable_Column_DownloadTable);
            }
        }
    }

    {  //  Filterable and/or Descriptive Annotations at Protein Level

        for ( const projectSearchId of projectSearchIds ) {

            const annotationTypeItems_For_ProjectSearchId = dataPageStateManager_DataFrom_Server.get_annotationTypeData_Root().annotationTypeItems_PerProjectSearchId_Map.get(projectSearchId)
            if ( ! annotationTypeItems_For_ProjectSearchId ) {
                const msg = "No entry in dataPageStateManager.get_annotationTypeData_Root().annotationTypeItems_PerProjectSearchId_Map for projectSearchId: " + projectSearchId;
                console.warn(msg)
                throw Error(msg)
            }

            let searchDataLookupParams_For_Single_ProjectSearchId: SearchDataLookupParams_For_Single_ProjectSearchId
            {
                for (const paramsForProjectSearchIdsList_Entry of searchDataLookupParamsRoot.paramsForProjectSearchIds.paramsForProjectSearchIdsList) {
                    if (paramsForProjectSearchIdsList_Entry.projectSearchId === projectSearchId) {
                        searchDataLookupParams_For_Single_ProjectSearchId = paramsForProjectSearchIdsList_Entry;
                        break;
                    }
                }
                if ( ! searchDataLookupParams_For_Single_ProjectSearchId ) {

                    continue // EARLY CONTINUE

                    // const msg = "No entry in searchDataLookupParamsRoot.paramsForProjectSearchIds.paramsForProjectSearchIdsList for projectSearchId: " + projectSearchId;
                    // console.warn(msg)
                    // throw Error(msg)
                }
            }

            let searchId_Addition_For_AnnotationTypeName_ForWhen_MultipleSearches = ""

            if ( projectSearchIds.length > 1 ) {
                const searchNameObject = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObject ) {
                    throw Error( "No searchNameObject from searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId );
                }
                searchId_Addition_For_AnnotationTypeName_ForWhen_MultipleSearches = " (" + searchNameObject.searchId + ")"
            }

            if ( searchDataLookupParams_For_Single_ProjectSearchId.matchedProteinAnnTypeDisplay && searchDataLookupParams_For_Single_ProjectSearchId.matchedProteinAnnTypeDisplay.length > 0 ) {

                //  Add AnnotationTypeIds Used For Display
                for ( const annTypeIdDisplay_Entry of searchDataLookupParams_For_Single_ProjectSearchId.matchedProteinAnnTypeDisplay ) {

                    {  //  Try Filterable
                        const matchedProteinFilterableAnnotationType = annotationTypeItems_For_ProjectSearchId.matchedProteinFilterableAnnotationTypes.get( annTypeIdDisplay_Entry )
                        if ( matchedProteinFilterableAnnotationType ) {

                            //  Have Filterable Annotation Type Data for Annotation Type Id

                            const displayName = matchedProteinFilterableAnnotationType.name + searchId_Addition_For_AnnotationTypeName_ForWhen_MultipleSearches

                            const column = new DataTable_Column( {
                                id: displayName,
                                displayName,
                                width: 80,
                                sortable: true,
                                onlyShow_ValueDisplay_FirstRowOfGroup: true
                            } );

                            columns.push( column );

                            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable( { cell_ColumnHeader_String: displayName } );
                            dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );

                            continue // EARLY CONTINUE
                        }
                    }
                    {  //  Try Descriptive
                        const matchedProteinDescriptiveAnnotationType = annotationTypeItems_For_ProjectSearchId.matchedProteinDescriptiveAnnotationTypes.get( annTypeIdDisplay_Entry )
                        if ( matchedProteinDescriptiveAnnotationType ) {

                            //  Have Descriptive Annotation Type Data for Annotation Type Id

                            const displayName = matchedProteinDescriptiveAnnotationType.name + searchId_Addition_For_AnnotationTypeName_ForWhen_MultipleSearches

                            const column = new DataTable_Column( {
                                id: displayName,
                                displayName,
                                width: 80,
                                sortable: false,
                                onlyShow_ValueDisplay_FirstRowOfGroup: true
                            } );

                            columns.push( column );

                            const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable( { cell_ColumnHeader_String: displayName } );
                            dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );

                            continue // EARLY CONTINUE
                        }
                    }

                    //  NOT found in Filterable or Descriptive so error

                    const msg = "annTypeIdDisplay_Entry not found in annotationTypeItems_For_ProjectSearchId.matchedProteinFilterableAnnotationTypes or annotationTypeItems_For_ProjectSearchId.matchedProteinDescriptiveAnnotationTypes. annTypeIdDisplay_Entry: " + annTypeIdDisplay_Entry
                    console.warn( msg )
                    throw Error( msg )
                }
            }
        }
    }

    ///  !!!!!

    //  Next are ONLY for Download

    if ( ! proteinGrouping_CentralStateManagerObjectClass.isGroupProteins_No_Grouping() ) {

        //  IS Grouping so add Protein Group Number

        const displayName = 'Protein Group Number';

        //   ONLY for Download

        const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
        dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
    }

    if ( proteinGrouping_CentralStateManagerObjectClass.isGroupProteins_NonSubset_Groups() ) {

        //  non subset groups so add Is Subset

        const displayName = 'Is Subset';

        //   ONLY for Download

        const dataTable_Column_DownloadTable = new DataTable_Column_DownloadTable({ cell_ColumnHeader_String : displayName });
        dataTable_Column_DownloadTable_Entries.push( dataTable_Column_DownloadTable );
    }

    const dataTable_RootTableDataObject_Both_ColumnArrays = new DataTable_RootTableDataObject_Both_ColumnArrays({ columns: columns, columns_tableDownload: dataTable_Column_DownloadTable_Entries });

    return dataTable_RootTableDataObject_Both_ColumnArrays;
}


////////////////

/**
 * Create dataGroupObjects object  for DataTable
 *
 * For YES Grouping of Proteins
 */
const _renderToPageProteinList_Create_dataGroupObjects_YES_ProteinGroups = function(
    {
        proteinDisplayData, projectSearchIds, searchSubGroupIds,
        dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId, singleProteinRowClickHandler_Callback,
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
    } : {

        proteinDisplayData: ProteinDisplayData_From_createProteinDisplayData_ProteinList
        projectSearchIds  : Array<number>
        searchSubGroupIds : Array<number>  //  undefined or null when not applicable
        dataPageStateManager_DataFrom_Server : DataPageStateManager
        searchDataLookupParamsRoot: SearchDataLookupParameters_Root
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId : Map<number, Array<ProteinNameDescriptionCacheEntry>>
        singleProteinRowClickHandler_Callback : ProteinViewPage_Display__singleProteinRow_ClickHandler
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject: ProteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject

    }) : Array<DataTable_DataGroupRowEntry> {

    const dataTable_DataGroupRowEntries : Array<DataTable_DataGroupRowEntry> = [];

    if ( ( ! proteinDisplayData.proteinGroupsList ) || proteinDisplayData.proteinGroupsList.length === 0 ) {
        //  No data so return empty array
        return dataTable_DataGroupRowEntries; // EARLY RETURN
    }

    let proteinList_Grouped_MaxLength = 0;

    let groupNumber = 0;

    //  Populate dataGroupObjects
    for ( const groupedProteinItem of proteinDisplayData.proteinGroupsList ) {

        groupNumber++;

        if ( proteinList_Grouped_MaxLength < groupedProteinItem.proteinList_Grouped.length ) {
            proteinList_Grouped_MaxLength = groupedProteinItem.proteinList_Grouped.length;
        }

        const greyOutRow = ! groupedProteinItem.proteinGroup.passesFilter;
        const isSubsetGroup = groupedProteinItem.isSubsetGroup;

        const dataTable_DataRowEntries = _renderToPageProteinList_Create_dataObjects_NO_ProteinGroups({
            groupNumber, greyOutRow, isSubsetGroup, proteinList : groupedProteinItem.proteinList_Grouped, projectSearchIds, searchSubGroupIds,
            dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
            proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId, singleProteinRowClickHandler_Callback,
            proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
        });

        const first_dataTable_DataRowEntry = dataTable_DataRowEntries[ 0 ];

        const dataTable_DataGroupRowEntry = new DataTable_DataGroupRowEntry({
            dataTable_DataRowEntries,
            columnEntries : first_dataTable_DataRowEntry.columnEntries,
            sortOrder_OnEquals : first_dataTable_DataRowEntry.sortOrder_OnEquals,
            uniqueId : first_dataTable_DataRowEntry.uniqueId
        });

        dataTable_DataGroupRowEntries.push( dataTable_DataGroupRowEntry );
    }

    console.log("proteinList_Grouped_MaxLength: " + proteinList_Grouped_MaxLength );

    return dataTable_DataGroupRowEntries;
}

//////////////////////


/**
 * Create dataObjects object  for DataTable
 *
 * For NO Grouping of Proteins
 */
const _renderToPageProteinList_Create_dataObjects_NO_ProteinGroups = function(
    {
        groupNumber, greyOutRow, isSubsetGroup, proteinList, projectSearchIds, searchSubGroupIds,
        dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId, singleProteinRowClickHandler_Callback,
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
    } : {
        groupNumber: number
        greyOutRow : boolean  //  Set greyOutRow on all rows
        isSubsetGroup: boolean  //  On Download, Set isSubsetGroup flag
        proteinList : Array<ProteinDataDisplay_ProteinList_Item>
        projectSearchIds : Array<number>
        searchSubGroupIds : Array<number>  //  undefined or null when not applicable
        dataPageStateManager_DataFrom_Server : DataPageStateManager
        searchDataLookupParamsRoot: SearchDataLookupParameters_Root
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId : Map<number, Array<ProteinNameDescriptionCacheEntry>>
        singleProteinRowClickHandler_Callback : ProteinViewPage_Display__singleProteinRow_ClickHandler
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject: ProteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject

    }) : Array<DataTable_DataRowEntry> {

    const dataTable_DataRowEntries = _createProteinList_ForDataTable( {
        groupNumber, greyOutRow, isSubsetGroup, proteinList, projectSearchIds, searchSubGroupIds,
        dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId, singleProteinRowClickHandler_Callback,
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
    } );

    return dataTable_DataRowEntries;
}

/**
 *
 */
const _createProteinList_ForDataTable = function(
    {
        groupNumber, greyOutRow, isSubsetGroup, proteinList, projectSearchIds, searchSubGroupIds,
        dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId, singleProteinRowClickHandler_Callback, proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
    } : {
        groupNumber: number
        greyOutRow : boolean  //  Set greyOutRow on all rows
        isSubsetGroup: boolean  //  On Download, Set isSubsetGroup flag
        proteinList : Array<ProteinDataDisplay_ProteinList_Item>
        projectSearchIds : Array<number>
        searchSubGroupIds : Array<number>  //  undefined or null when not applicable
        dataPageStateManager_DataFrom_Server : DataPageStateManager
        searchDataLookupParamsRoot: SearchDataLookupParameters_Root
        proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId : Map<number, Array<ProteinNameDescriptionCacheEntry>>
        singleProteinRowClickHandler_Callback : ProteinViewPage_Display__singleProteinRow_ClickHandler
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject: ProteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject

    }) : Array<DataTable_DataRowEntry> {

    const proteinList_ForDataTable : Array<DataTable_DataRowEntry> = [];

    if ( ( ! proteinList ) || proteinList.length === 0 ) {
        //  No data so return empty array
        return proteinList_ForDataTable; // EARLY RETURN
    }

    let index = 0;
    for ( const proteinListItem of proteinList ) {

        const proteinSequenceVersionId = proteinListItem.proteinSequenceVersionId;

        const proteinNameDescriptionForToolip = proteinNameDescriptionForToolip_Key_ProteinSequenceVersionId.get( proteinSequenceVersionId );
        if ( ! proteinNameDescriptionForToolip ) {
            const msg = "( ! proteinNameDescriptionForToolip ) in createProteinList_ForDataTable_SingleSearch for proteinSequenceVersionId: " + proteinSequenceVersionId;
            console.warn(msg);
            throw Error( msg );
        }

        proteinList_ForDataTable.push(
            _createProteinItem_DataTableEntry( {
                groupNumber, greyOutRow, isSubsetGroup, proteinListItem, arrayIndex : index, projectSearchIds, searchSubGroupIds,
                dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
                proteinNameDescriptionForToolip, singleProteinRowClickHandler_Callback,
                proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
            } )
        );
        index++;
    }
    return proteinList_ForDataTable;
}

////////////////

/**
 * Create object
 */
const _createProteinItem_DataTableEntry = function(
    {
        groupNumber, greyOutRow, isSubsetGroup, proteinListItem, arrayIndex, projectSearchIds, searchSubGroupIds,
        dataPageStateManager_DataFrom_Server, searchDataLookupParamsRoot,
        proteinNameDescriptionForToolip, singleProteinRowClickHandler_Callback,
        proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject
    } : {
    groupNumber: number
    greyOutRow : boolean  //  Set greyOutRow on all rows
    isSubsetGroup: boolean  //  On Download, Set isSubsetGroup flag
    proteinListItem : ProteinDataDisplay_ProteinList_Item
    arrayIndex : number
    projectSearchIds : Array<number>
    searchSubGroupIds : Array<number>  //  undefined or null when not applicable
    dataPageStateManager_DataFrom_Server : DataPageStateManager
    searchDataLookupParamsRoot: SearchDataLookupParameters_Root
    proteinNameDescriptionForToolip : Array<ProteinNameDescriptionCacheEntry>
    singleProteinRowClickHandler_Callback : ProteinViewPage_Display__singleProteinRow_ClickHandler
    proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject: ProteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject

}) : DataTable_DataRowEntry {

    //  For getting search info for projectSearchIds
    const searchData_SearchName_Etc_Root = dataPageStateManager_DataFrom_Server.get_searchData_SearchName_Etc_Root();

    //  Column entries for this data row in data table
    const columnEntries : DataTable_DataRow_ColumnEntry[] = [];
    const dataColumns_tableDownload : Array<DataTable_DataRowEntry_DownloadTable_SingleColumn> = [];

    {  // proteinNames
        if ( ! proteinListItem.proteinNames ) {
            throw Error( "_createProteinItem_DataTableEntry(...): proteinListItem.proteinNames not populated: " + proteinListItem.proteinNames )
        }

        const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough : DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
            ( params : DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough_Params ) : React.JSX.Element => {

                return get_ProteinName_ProteinDescription_Tooltip_Contents({ proteinNameDescriptionForToolip })
            }

        const valueDisplay = proteinListItem.proteinNames;
        const searchEntriesForColumn : Array<string> = [ valueDisplay ];
        const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn });
        const columnEntry = new DataTable_DataRow_ColumnEntry({
            searchTableData,
            valueDisplay,
            valueSort : proteinListItem.proteinNames,
            tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
        })
        columnEntries.push( columnEntry );

        const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
        dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
    }
    {  // proteinDescription
        let proteinDescription = proteinListItem.proteinDescriptions;
        if ( ! proteinDescription ) {
            proteinDescription = "";  // Was undefined, null, or empty string so make it empty string
        }

        const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough : DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
            ( params : DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough_Params ) : React.JSX.Element => {

                return get_ProteinName_ProteinDescription_Tooltip_Contents({ proteinNameDescriptionForToolip })
            }

        const valueDisplay = proteinDescription;
        const searchEntriesForColumn : Array<string> = [ valueDisplay ]
        const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
        const columnEntry = new DataTable_DataRow_ColumnEntry({
            searchTableData,
            valueDisplay,
            valueSort : proteinDescription,
            tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
        })
        columnEntries.push( columnEntry );

        const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
        dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
    }


    if ( ( ! searchSubGroupIds ) ) {

        //   NO Sub Groups so display Sequence Coverage

        //  WAS  if ( projectSearchIds.length === 1 && ( ! searchSubGroupIds ) ) {

            //  Only 1 search and NO Sub Groups so display Sequence Coverage

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_SequenceCoverage_Selected() ) {

            // Per Search:  proteinCoverageRatioDisplay

            for ( const projectSearchId of projectSearchIds ) {

                let proteinCoverageRatio = 0;  // default to zero if no entry
                let proteinCoverageRatioDisplay = "0";  // default to zero if no entry

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get( projectSearchId );
                if ( proteinItemRecord ) {
                    proteinCoverageRatio = proteinItemRecord.proteinCoverageRatio;
                    proteinCoverageRatioDisplay = proteinItemRecord.proteinCoverageRatioDisplay;
                }


                //  searchNames // Object with property name is projectSearchId as number

                const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObj ) {
                    const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                    console.warn( msg );
                    throw Error( msg );
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        // let searchName_ShortName_Display = ""
                        //
                        // if ( searchNameObj.searchShortName ) {
                        //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                        // }
                        // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                        const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                        return (
                            <div>
                                <div>
                                    Sequence Coverage
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Search: { searchLabel }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = proteinCoverageRatioDisplay;
                const searchEntriesForColumn : Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort : proteinCoverageRatio,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }
    }

    if ( projectSearchIds.length === 1 && searchSubGroupIds ) {

        //  Sequence Coverage Per Search Sub Group

        //  Only 1 search  AND Sub Groups

        //  YES Sub Groups so display Sub Group data

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_SequenceCoverage_Selected() ) {

            const projectSearchId = projectSearchIds[0];

            const searchSubGroups_Root = dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root();
            if ( ! searchSubGroups_Root ) {
                throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root(); return nothing for projectSearchId: " + projectSearchId );
            }
            const searchSubGroups_ForProjectSearchId = searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId );
            if ( ! searchSubGroups_ForProjectSearchId ) {
                throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId ); return nothing for projectSearchId: " + projectSearchId );
            }

            for ( const searchSubGroupId of searchSubGroupIds ) {

                let proteinCoverageRatio = 0;  // default to zero if no entry
                let proteinCoverageRatioDisplay = "0";  // default to zero if no entry

                const protein_SubItem_Record = proteinListItem.protein_SubItem_Records_Map_Key_SubGroup_Id.get( searchSubGroupId )
                if ( protein_SubItem_Record ) {
                    if ( protein_SubItem_Record.proteinCoverageRatio === undefined || protein_SubItem_Record.proteinCoverageRatio === null ) {
                        const msg = "( protein_SubItem_Record.proteinCoverageRatio === undefined || protein_SubItem_Record.proteinCoverageRatio === null ). //  YES Sub Groups so display Sub Group data. true get_SequenceCoverage_Selected.  ";
                        console.warn(msg);
                        throw Error(msg);
                    }
                    proteinCoverageRatio = protein_SubItem_Record.proteinCoverageRatio;
                    proteinCoverageRatioDisplay = protein_SubItem_Record.proteinCoverageRatioDisplay;
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                        if ( ! searchSubGroup ) {
                            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                                + ", projectSearchId: " + projectSearchId );
                        }

                        return (
                            <div>
                                <div>
                                    Sequence Coverage
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Sub Search: { searchSubGroup.subgroupName_Display }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = proteinCoverageRatioDisplay;
                const searchEntriesForColumn : Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort : proteinCoverageRatio,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }
    }

    if ( projectSearchIds.length === 1 && ( ! searchSubGroupIds ) ) {

        //  Only 1 search and NOT Sub Groups

        const projectSearchId = projectSearchIds[0];

        const protein_SubItem_Record__For__projectSearchId = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get( projectSearchId );

        //  Num PSMs, NSAF, Distinct Peptides, and Distinct Peptides Unique

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_PsmCount_Selected() ) {

            //  Num PSMs

            let psmCount = 0;

            if ( protein_SubItem_Record__For__projectSearchId ) {
                psmCount = protein_SubItem_Record__For__projectSearchId.numPsms;
            }


            //  searchNames // Object with property name is projectSearchId as number

            const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
            if ( ! searchNameObj ) {
                const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                console.warn( msg );
                throw Error( msg );
            }

            const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                () => {

                    // let searchName_ShortName_Display = ""
                    //
                    // if ( searchNameObj.searchShortName ) {
                    //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                    // }
                    // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                    const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                    return (
                        <div>
                            <div>
                                PSMs
                            </div>
                            <div style={ { marginTop: 5 } }>
                                Search: { searchLabel }
                            </div>
                        </div>
                    )
                }

            const valueDisplay = psmCount.toLocaleString();
            const searchEntriesForColumn : Array<string> = [ valueDisplay ]
            const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
            const columnEntry = new DataTable_DataRow_ColumnEntry({
                searchTableData,
                valueDisplay,
                valueSort : psmCount,
                tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
            })
            columnEntries.push( columnEntry );

            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
            dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_Selected() ) {

            //  NSAF

            let nsaf = 0;

            if ( protein_SubItem_Record__For__projectSearchId ) {
                nsaf = protein_SubItem_Record__For__projectSearchId.nsaf;
            }

            const nsafString = proteinView_nsaf_formatNumber_ForDisplayInTable( nsaf );


            const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
            if ( ! searchNameObj ) {
                const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                console.warn( msg );
                throw Error( msg );
            }

            const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                () => {

                    // let searchName_ShortName_Display = ""
                    //
                    // if ( searchNameObj.searchShortName ) {
                    //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                    // }
                    // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                    const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                    return (
                        <div>
                            <div>
                                NSAF
                            </div>
                            <div style={ { marginTop: 5 } }>
                                Search: { searchLabel }
                            </div>
                        </div>
                    )
                }

            const valueDisplay = nsafString;
            const searchEntriesForColumn : Array<string> = [ valueDisplay ]
            const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
            const columnEntry = new DataTable_DataRow_ColumnEntry({
                searchTableData,
                valueDisplay,
                valueSort : nsaf,
                tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
            })
            columnEntries.push( columnEntry );

            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
            dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  Adjusted_Spectral_Count_ABACUS

            let valueNumer = 0;

            if ( protein_SubItem_Record__For__projectSearchId ) {
                valueNumer = protein_SubItem_Record__For__projectSearchId.adjusted_Spectral_Count_ABACUS;
            }

            const valueString = proteinView_Adjusted_Spectral_Count_ABACUS_formatNumber_ForDisplayInTable( valueNumer );


            const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
            if ( ! searchNameObj ) {
                const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                console.warn( msg );
                throw Error( msg );
            }

            const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                () => {

                    // let searchName_ShortName_Display = ""
                    //
                    // if ( searchNameObj.searchShortName ) {
                    //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                    // }
                    // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                    const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                    return (
                        <div>
                            <div>
                                Adjusted Spectral Count (ABACUS)
                            </div>
                            <div style={ { marginTop: 5 } }>
                                Search: { searchLabel }
                            </div>
                        </div>
                    )
                }

            const valueDisplay = valueString;
            const searchEntriesForColumn : Array<string> = [ valueDisplay ]
            const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
            const columnEntry = new DataTable_DataRow_ColumnEntry({
                searchTableData,
                valueDisplay,
                valueSort : valueNumer,
                tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
            })
            columnEntries.push( columnEntry );

            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
            dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_USING__Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  NSAF Adjusted_Spectral_Count_ABACUS

            let valueNumer = 0;

            if ( protein_SubItem_Record__For__projectSearchId ) {
                valueNumer = protein_SubItem_Record__For__projectSearchId.nsaf__Using_Adjusted_Spectral_Count_ABACUS;
            }

            const valueString = proteinView_nsaf_formatNumber_ForDisplayInTable( valueNumer );


            const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
            if ( ! searchNameObj ) {
                const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                console.warn( msg );
                throw Error( msg );
            }

            const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                () => {

                    // let searchName_ShortName_Display = ""
                    //
                    // if ( searchNameObj.searchShortName ) {
                    //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                    // }
                    // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                    const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                    return (
                        <div>
                            <div>
                                NSAF: Adjusted Spectral Count (ABACUS)
                            </div>
                            <div style={ { marginTop: 5 } }>
                                Search: { searchLabel }
                            </div>
                        </div>
                    )
                }

            const valueDisplay = valueString;
            const searchEntriesForColumn : Array<string> = [ valueDisplay ]
            const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
            const columnEntry = new DataTable_DataRow_ColumnEntry({
                searchTableData,
                valueDisplay,
                valueSort : valueNumer,
                tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
            })
            columnEntries.push( columnEntry );

            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
            dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_DistinctPeptideCount_Selected() ) {

            // Num Reported Peptides

            let peptideCount = 0;
            {
                if ( protein_SubItem_Record__For__projectSearchId ) {
                    peptideCount = protein_SubItem_Record__For__projectSearchId.peptideCount;
                }
            }


            const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
            if ( ! searchNameObj ) {
                const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                console.warn( msg );
                throw Error( msg );
            }

            const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                () => {

                    // let searchName_ShortName_Display = ""
                    //
                    // if ( searchNameObj.searchShortName ) {
                    //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                    // }
                    // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                    const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                    return (
                        <div>
                            <div>
                                Distinct Peptides
                            </div>
                            <div style={ { marginTop: 5 } }>
                                Search: { searchLabel }
                            </div>
                        </div>
                    )
                }

            const valueDisplay = peptideCount.toLocaleString();
            const searchEntriesForColumn: Array<string> = [valueDisplay]
            const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({searchEntriesForColumn})
            const columnEntry = new DataTable_DataRow_ColumnEntry({
                searchTableData,
                valueDisplay,
                valueSort: peptideCount,
                tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
            })
            columnEntries.push(columnEntry);

            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({cell_ColumnData_String: valueDisplay})
            dataColumns_tableDownload.push(dataTable_DataRowEntry_DownloadTable_SingleColumn);
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_UniquePeptideCount_Selected() ) {

            // Reported Peptides Unique

            let uniquePeptideCount = 0;
            {
                if ( protein_SubItem_Record__For__projectSearchId ) {
                    uniquePeptideCount = protein_SubItem_Record__For__projectSearchId.uniquePeptideCount;
                }
            }


            const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
            if ( ! searchNameObj ) {
                const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                console.warn( msg );
                throw Error( msg );
            }

            const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                () => {

                    // let searchName_ShortName_Display = ""
                    //
                    // if ( searchNameObj.searchShortName ) {
                    //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                    // }
                    // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                    const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                    return (
                        <div>
                            <div>
                                Unique Peptides
                            </div>
                            <div style={ { marginTop: 5 } }>
                                Search: { searchLabel }
                            </div>
                        </div>
                    )
                }

            const valueDisplay = uniquePeptideCount.toLocaleString();
            const searchEntriesForColumn: Array<string> = [valueDisplay]
            const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({searchEntriesForColumn})
            const columnEntry = new DataTable_DataRow_ColumnEntry({
                searchTableData,
                valueDisplay,
                valueSort: uniquePeptideCount,
                tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
            })
            columnEntries.push(columnEntry);

            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({cell_ColumnData_String: valueDisplay})
            dataColumns_tableDownload.push(dataTable_DataRowEntry_DownloadTable_SingleColumn);
        }
    }

    if ( projectSearchIds.length === 1 && searchSubGroupIds ) {

        //  Only 1 search AND Sub Groups

        //  YES Sub Groups so display Sub Group data

        const projectSearchId = projectSearchIds[0];

        const searchSubGroups_Root = dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root();
        if ( ! searchSubGroups_Root ) {
            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: dataPageStateManager_DataFrom_Server.get_SearchSubGroups_Root(); return nothing for projectSearchId: " + projectSearchId );
        }
        const searchSubGroups_ForProjectSearchId = searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId );
        if ( ! searchSubGroups_ForProjectSearchId ) {
            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_Root.get_searchSubGroups_ForProjectSearchId( projectSearchId ); return nothing for projectSearchId: " + projectSearchId );
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_PsmCount_Selected() ) {

            // numPsms per search sub group

            for ( const searchSubGroupId of searchSubGroupIds ) {

                let numPsms = 0;  // default to zero if no entry

                const protein_SubItem_Record = proteinListItem.protein_SubItem_Records_Map_Key_SubGroup_Id.get( searchSubGroupId )
                if ( protein_SubItem_Record ) {
                    numPsms = protein_SubItem_Record.numPsms;
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                        if ( ! searchSubGroup ) {
                            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                                + ", projectSearchId: " + projectSearchId );
                        }

                        return (
                            <div>
                                <div>
                                    PSMs
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Sub Search: { searchSubGroup.subgroupName_Display }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = numPsms.toLocaleString();
                const searchEntriesForColumn : Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort : numPsms,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_Selected() ) {

            //  NSAF per search sub group

            for ( const searchSubGroupId of searchSubGroupIds ) {

                let nsaf = 0;  // default to zero if no entry

                const protein_SubItem_Record = proteinListItem.protein_SubItem_Records_Map_Key_SubGroup_Id.get( searchSubGroupId )
                if ( protein_SubItem_Record ) {
                    nsaf = protein_SubItem_Record.nsaf;
                }

                const nsafString = proteinView_nsaf_formatNumber_ForDisplayInTable( nsaf );

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                        if ( ! searchSubGroup ) {
                            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                                + ", projectSearchId: " + projectSearchId );
                        }

                        return (
                            <div>
                                <div>
                                    NSAF
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Sub Search: { searchSubGroup.subgroupName_Display }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = nsafString;
                const searchEntriesForColumn : Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort : nsaf,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  Adjusted_Spectral_Count_ABACUS per search sub group

            for ( const searchSubGroupId of searchSubGroupIds ) {

                let valueNumer = 0;

                const protein_SubItem_Record = proteinListItem.protein_SubItem_Records_Map_Key_SubGroup_Id.get( searchSubGroupId )
                if ( protein_SubItem_Record ) {
                    valueNumer = protein_SubItem_Record.adjusted_Spectral_Count_ABACUS;
                }

                const valueString = proteinView_Adjusted_Spectral_Count_ABACUS_formatNumber_ForDisplayInTable( valueNumer );

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                        if ( ! searchSubGroup ) {
                            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                                + ", projectSearchId: " + projectSearchId );
                        }

                        return (
                            <div>
                                <div>
                                    Adjusted Spectral Count (ABACUS)
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Sub Search: { searchSubGroup.subgroupName_Display }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = valueString;
                const searchEntriesForColumn: Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData( { searchEntriesForColumn } )
                const columnEntry = new DataTable_DataRow_ColumnEntry( {
                    searchTableData,
                    valueDisplay,
                    valueSort: valueNumer,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                } )
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn( { cell_ColumnData_String: valueDisplay } )
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_USING__Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  NSAF Adjusted_Spectral_Count_ABACUS per search sub group

            for ( const searchSubGroupId of searchSubGroupIds ) {

                let valueNumer = 0;

                const protein_SubItem_Record = proteinListItem.protein_SubItem_Records_Map_Key_SubGroup_Id.get( searchSubGroupId )
                if ( protein_SubItem_Record ) {
                    valueNumer = protein_SubItem_Record.nsaf__Using_Adjusted_Spectral_Count_ABACUS;
                }

                const valueString = proteinView_nsaf_formatNumber_ForDisplayInTable( valueNumer );

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                        if ( ! searchSubGroup ) {
                            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                                + ", projectSearchId: " + projectSearchId );
                        }

                        return (
                            <div>
                                <div>
                                    NSAF: Adjusted Spectral Count (ABACUS)
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Sub Search: { searchSubGroup.subgroupName_Display }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = valueString;
                const searchEntriesForColumn: Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData( { searchEntriesForColumn } )
                const columnEntry = new DataTable_DataRow_ColumnEntry( {
                    searchTableData,
                    valueDisplay,
                    valueSort: valueNumer,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                } )
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn( { cell_ColumnData_String: valueDisplay } )
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }

        // Num Reported Peptides and Num Reported Peptides Unique per search sub group

        for (const searchSubGroupId of searchSubGroupIds) {

            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_DistinctPeptideCount_Selected() ) {

                // Num Distinct Peptides for search sub group

                let num = 0;  // default to zero if no entry

                const protein_SubItem_Record = proteinListItem.protein_SubItem_Records_Map_Key_SubGroup_Id.get( searchSubGroupId )
                if ( protein_SubItem_Record ) {
                    num = protein_SubItem_Record.peptideCount;
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                        if ( ! searchSubGroup ) {
                            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                                + ", projectSearchId: " + projectSearchId );
                        }

                        return (
                            <div>
                                <div>
                                    Distinct Peptides
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Sub Search: { searchSubGroup.subgroupName_Display }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = num.toLocaleString();
                const searchEntriesForColumn: Array<string> = [valueDisplay]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({searchEntriesForColumn})
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort: num,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push(columnEntry);

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({cell_ColumnData_String: valueDisplay})
                dataColumns_tableDownload.push(dataTable_DataRowEntry_DownloadTable_SingleColumn);
            }


            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_UniquePeptideCount_Selected() ) {

                // Num Unique Distinct Peptides for search sub group

                let num = 0;  // default to zero if no entry

                const protein_SubItem_Record = proteinListItem.protein_SubItem_Records_Map_Key_SubGroup_Id.get( searchSubGroupId )
                if ( protein_SubItem_Record ) {
                    num = protein_SubItem_Record.uniquePeptideCount;
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        const searchSubGroup = searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId );
                        if ( ! searchSubGroup ) {
                            throw Error("getProteinDataTableColumns_SingleSearch__SearchSubGroup: searchSubGroups_ForProjectSearchId.get_searchSubGroup_For_SearchSubGroup_Id( searchSubGroupId ); return nothing for searchSubGroupId: " + searchSubGroupId
                                + ", projectSearchId: " + projectSearchId );
                        }

                        return (
                            <div>
                                <div>
                                    Unique Peptides
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Sub Search: { searchSubGroup.subgroupName_Display }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = num.toLocaleString();
                const searchEntriesForColumn: Array<string> = [valueDisplay]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({searchEntriesForColumn})
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort: num,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push(columnEntry);

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({cell_ColumnData_String: valueDisplay})
                dataColumns_tableDownload.push(dataTable_DataRowEntry_DownloadTable_SingleColumn);
            }
        }
    }

    if ( projectSearchIds.length > 1 ) {

        //  More than 1 Search

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_PsmCount_Selected() ) {

            // Per Search:  numPsms

            for ( const projectSearchId of projectSearchIds ) {

                let numPsms = 0;  // default to zero if no entry

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get( projectSearchId );
                if ( proteinItemRecord ) {
                    numPsms = proteinItemRecord.numPsms;
                }

                //  searchNames // Object with property name is projectSearchId as number

                const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObj ) {
                    const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                    console.warn( msg );
                    throw Error( msg );
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        // let searchName_ShortName_Display = ""
                        //
                        // if ( searchNameObj.searchShortName ) {
                        //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                        // }
                        // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                        const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                        return (
                            <div>
                                <div>
                                    PSMs
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Search: { searchLabel }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = numPsms.toLocaleString();
                const searchEntriesForColumn : Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort : numPsms,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_Selected() ) {

            //  NSAF per search

            for ( const projectSearchId of projectSearchIds ) {

                let nsaf = 0;  // default to zero if no entry

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get( projectSearchId );
                if ( proteinItemRecord ) {
                    nsaf = proteinItemRecord.nsaf;
                }

                //  searchNames // Object with property name is projectSearchId as number

                const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObj ) {
                    const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                    console.warn( msg );
                    throw Error( msg );
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        // let searchName_ShortName_Display = ""
                        //
                        // if ( searchNameObj.searchShortName ) {
                        //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                        // }
                        // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                        const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                        return (
                            <div>
                                <div>
                                    NSAF
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Search: { searchLabel }
                                </div>
                            </div>
                        )
                    }

                const nsafString = proteinView_nsaf_formatNumber_ForDisplayInTable( nsaf );

                const valueDisplay = nsafString;
                const searchEntriesForColumn : Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort : nsaf,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }

        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  Adjusted_Spectral_Count_ABACUS per search

            for ( const projectSearchId of projectSearchIds ) {

                let valueNumer = 0;

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get( projectSearchId );
                if ( proteinItemRecord ) {
                    valueNumer = proteinItemRecord.adjusted_Spectral_Count_ABACUS;
                }

                //  searchNames // Object with property name is projectSearchId as number

                const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObj ) {
                    const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                    console.warn( msg );
                    throw Error( msg );
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        // let searchName_ShortName_Display = ""
                        //
                        // if ( searchNameObj.searchShortName ) {
                        //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                        // }
                        // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                        const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                        return (
                            <div>
                                <div>
                                    Adjusted Spectral Count (ABACUS)
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Search: { searchLabel }
                                </div>
                            </div>
                        )
                    }

                const valueString = proteinView_Adjusted_Spectral_Count_ABACUS_formatNumber_ForDisplayInTable( valueNumer );

                const valueDisplay = valueString;
                const searchEntriesForColumn: Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData( { searchEntriesForColumn } )
                const columnEntry = new DataTable_DataRow_ColumnEntry( {
                    searchTableData,
                    valueDisplay,
                    valueSort: valueNumer,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                } )
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn( { cell_ColumnData_String: valueDisplay } )
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }


        if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_NSAF_USING__Adjusted_Spectral_Count_ABACUS_Selected() ) {

            //  NSAF Using Adjusted_Spectral_Count_ABACUS_

            for ( const projectSearchId of projectSearchIds ) {

                //  NSAF Adjusted_Spectral_Count_ABACUS

                let valueNumer = 0;

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get( projectSearchId );
                if ( proteinItemRecord ) {
                    valueNumer = proteinItemRecord.nsaf__Using_Adjusted_Spectral_Count_ABACUS;
                }

                //  searchNames // Object with property name is projectSearchId as number

                const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObj ) {
                    const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                    console.warn( msg );
                    throw Error( msg );
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        // let searchName_ShortName_Display = ""
                        //
                        // if ( searchNameObj.searchShortName ) {
                        //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                        // }
                        // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                        const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                        return (
                            <div>
                                <div>
                                    NSAF: Adjusted Spectral Count (ABACUS)
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Search: { searchLabel }
                                </div>
                            </div>
                        )
                    }

                const valueString = proteinView_nsaf_formatNumber_ForDisplayInTable( valueNumer );

                const valueDisplay = valueString;
                const searchEntriesForColumn : Array<string> = [ valueDisplay ]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({ searchEntriesForColumn })
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort : valueNumer,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push( columnEntry );

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: valueDisplay })
                dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
            }
        }

        //  Per Search: Num Distinct Peptides and Distinct Peptides Unique

        for ( const projectSearchId of projectSearchIds ) {

            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_DistinctPeptideCount_Selected() ) {

                // Num Distinct Peptides for search

                let num = 0;  // default to zero if no entry

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get(projectSearchId);
                if (proteinItemRecord) {
                    num = proteinItemRecord.peptideCount;
                }

                //  searchNames // Object with property name is projectSearchId as number

                const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObj ) {
                    const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                    console.warn( msg );
                    throw Error( msg );
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        // let searchName_ShortName_Display = ""
                        //
                        // if ( searchNameObj.searchShortName ) {
                        //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                        // }
                        // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                        const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                        return (
                            <div>
                                <div>
                                    Distinct Peptides
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Search: { searchLabel }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = num.toLocaleString();
                const searchEntriesForColumn: Array<string> = [valueDisplay]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({searchEntriesForColumn})
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort: num,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push(columnEntry);

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({cell_ColumnData_String: valueDisplay})
                dataColumns_tableDownload.push(dataTable_DataRowEntry_DownloadTable_SingleColumn);
            }

            if ( proteinViewPage_DisplayData_ProteinList__ProteinListColumnsDisplayContents_UserSelections_StateObject.get_UniquePeptideCount_Selected() ) {
                // Num Distinct Peptides Unique for search

                let num = 0;  // default to zero if no entry

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get(projectSearchId);
                if (proteinItemRecord) {
                    num = proteinItemRecord.uniquePeptideCount;
                }

                //  searchNames // Object with property name is projectSearchId as number

                const searchNameObj = searchData_SearchName_Etc_Root.get_SearchData_For_ProjectSearchId( projectSearchId );
                if ( ! searchNameObj ) {
                    const msg = "No value in searchData_SearchName_Etc_Root for projectSearchId: " + projectSearchId;
                    console.warn( msg );
                    throw Error( msg );
                }

                const tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough: DataTable_DataRow_ColumnEntry__tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough =
                    () => {

                        // let searchName_ShortName_Display = ""
                        //
                        // if ( searchNameObj.searchShortName ) {
                        //     searchName_ShortName_Display = "(" + searchNameObj.searchShortName + ") "
                        // }
                        // const searchLabel = "(" + searchNameObj.searchId + ") " + searchName_ShortName_Display + searchNameObj.name

                        const searchLabel = searchNameObj.searchLabel__SearchShortName_OR_SearchId

                        return (
                            <div>
                                <div>
                                    Unique Peptides
                                </div>
                                <div style={ { marginTop: 5 } }>
                                    Search: { searchLabel }
                                </div>
                            </div>
                        )
                    }

                const valueDisplay = num.toLocaleString();
                const searchEntriesForColumn: Array<string> = [valueDisplay]
                const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({searchEntriesForColumn})
                const columnEntry = new DataTable_DataRow_ColumnEntry({
                    searchTableData,
                    valueDisplay,
                    valueSort: num,
                    tooltipDisplay_FunctionCallback_Return_JSX_Element_NoDataPassThrough
                })
                columnEntries.push(columnEntry);

                const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({cell_ColumnData_String: valueDisplay})
                dataColumns_tableDownload.push(dataTable_DataRowEntry_DownloadTable_SingleColumn);
            }
        }
    }

    {  //  Filterable and/or Descriptive Annotations at Protein Level

        for ( const projectSearchId of projectSearchIds ) {

            const annotationTypeItems_For_ProjectSearchId = dataPageStateManager_DataFrom_Server.get_annotationTypeData_Root().annotationTypeItems_PerProjectSearchId_Map.get( projectSearchId )
            if ( ! annotationTypeItems_For_ProjectSearchId ) {
                const msg = "No entry in dataPageStateManager.get_annotationTypeData_Root().annotationTypeItems_PerProjectSearchId_Map for projectSearchId: " + projectSearchId;
                console.warn( msg )
                throw Error( msg )
            }

            let searchDataLookupParams_For_Single_ProjectSearchId: SearchDataLookupParams_For_Single_ProjectSearchId
            {
                for ( const paramsForProjectSearchIdsList_Entry of searchDataLookupParamsRoot.paramsForProjectSearchIds.paramsForProjectSearchIdsList ) {
                    if ( paramsForProjectSearchIdsList_Entry.projectSearchId === projectSearchId ) {
                        searchDataLookupParams_For_Single_ProjectSearchId = paramsForProjectSearchIdsList_Entry;
                        break;
                    }
                }
                if ( ! searchDataLookupParams_For_Single_ProjectSearchId ) {

                    continue // EARLY CONTINUE

                    // const msg = "No entry in searchDataLookupParamsRoot.paramsForProjectSearchIds.paramsForProjectSearchIdsList for projectSearchId: " + projectSearchId;
                    // console.warn(msg)
                    // throw Error(msg)
                }
            }

            if ( searchDataLookupParams_For_Single_ProjectSearchId.matchedProteinAnnTypeDisplay && searchDataLookupParams_For_Single_ProjectSearchId.matchedProteinAnnTypeDisplay.length > 0 ) {

                const proteinItemRecord = proteinListItem.protein_SubItem_Records_Map_Key_projectSearchId.get(projectSearchId);

                //  proteinItemRecord will be undefined if no data for this projectSearchId

                //  Add AnnotationTypeIds Used For Display
                for ( const annTypeIdDisplay_Entry of searchDataLookupParams_For_Single_ProjectSearchId.matchedProteinAnnTypeDisplay ) {

                    let valueDisplay: string = ""
                    let valueSort: number | string = ""   // Would be nice if no data always sorted to the bottom.  Maybe need another property that set to true.

                    if ( proteinItemRecord && proteinItemRecord.filterableDescriptiveAnnotationDisplayItem_Map_Key_AnnotationTypeId ) {

                        const annotationDisplayItem = proteinItemRecord.filterableDescriptiveAnnotationDisplayItem_Map_Key_AnnotationTypeId.get( annTypeIdDisplay_Entry )
                        if ( annotationDisplayItem ) {
                            valueDisplay = annotationDisplayItem.valueDisplay;
                            valueSort = annotationDisplayItem.valueSort
                        }
                    }
                    const searchEntriesForColumn: Array<string> = [valueDisplay]
                    const searchTableData = new DataTable_DataRow_ColumnEntry_SearchTableData({searchEntriesForColumn})
                    const columnEntry = new DataTable_DataRow_ColumnEntry({
                        searchTableData,
                        valueDisplay,
                        valueSort
                    })
                    columnEntries.push(columnEntry);

                    const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({cell_ColumnData_String: valueDisplay})
                    dataColumns_tableDownload.push(dataTable_DataRowEntry_DownloadTable_SingleColumn);
                }
            }
        }
    }

    ///////

    //  For Downloads Only

    {  //  groupNumber
        if ( groupNumber !== undefined && groupNumber !== null ) {

            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String: groupNumber.toString() })
            dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
        }
    }

    {  //  isSubsetGroup
        if ( isSubsetGroup !== undefined && isSubsetGroup !== null ) {

            let cell_ColumnData_String = _FALSE__DOWNLOAD_STRING;
            if ( isSubsetGroup ) {
                cell_ColumnData_String = _TRUE__DOWNLOAD_STRING;
            }
            const dataTable_DataRowEntry_DownloadTable_SingleColumn = new DataTable_DataRowEntry_DownloadTable_SingleColumn({ cell_ColumnData_String })
            dataColumns_tableDownload.push( dataTable_DataRowEntry_DownloadTable_SingleColumn );
        }
    }


    //////


    //  Create callback function

    const tableRowClickHandler_Callback_NoDataPassThrough : DataTable_DataRowEntry__tableRowClickHandler_Callback_NoDataPassThrough = ( params :  DataTable_DataRowEntry__tableRowClickHandler_Callback_NoDataPassThrough_Params ) : void => {
        const singleProteinRowClickHandler_Params : ProteinViewPage_Display__singleProteinRow_ClickHandler_Params = {
            dataTable_DataRowEntry__tableRowClickHandler_Callback_NoDataPassThrough_Params : params,
            proteinSequenceVersionId : proteinListItem.proteinSequenceVersionId
        }
        singleProteinRowClickHandler_Callback( singleProteinRowClickHandler_Params );
    }

    const dataTable_DataRowEntry_DownloadTable = new DataTable_DataRowEntry_DownloadTable({ dataColumns_tableDownload });

    //  Create DataTable_DataRowEntry

    const dataTable_DataRowEntry = new DataTable_DataRowEntry({
        uniqueId : proteinListItem.proteinSequenceVersionId,
        sortOrder_OnEquals : arrayIndex, // Original Sort Order
        greyOutRow : greyOutRow,
        columnEntries,
        dataTable_DataRowEntry_DownloadTable,
        tableRowClickHandler_Callback_NoDataPassThrough
    })

    return dataTable_DataRowEntry;
}
